import { useEffect, useRef } from 'react';
import { calculateProgressBarStyles } from '../../../utils/progressBar';
import css from '../MediaCard.module.scss';

type ProgressBarProps = {
  progress?: number;
};

export const ProgressBar = ({ progress }: ProgressBarProps) => {
  const barRef = useRef<HTMLDivElement>(null);
  const previousProgressRef = useRef<number | undefined>(undefined);
  const isInitialMountRef = useRef(true);

  useEffect(() => {
    if (!barRef.current) return;

    const currentProgress = progress ?? 0;
    const { visualProgress, fadeStartPercent } = calculateProgressBarStyles(currentProgress);

    // Set CSS variable for the mask fade point
    barRef.current.style.setProperty('--fade-start', `${fadeStartPercent}%`);

    // On initial mount, set the width directly
    if (isInitialMountRef.current) {
      barRef.current.style.width = `${visualProgress}%`;
      previousProgressRef.current = currentProgress;
      isInitialMountRef.current = false;
      return;
    }

    // On subsequent updates, only update if progress has actually changed
    // The CSS transition will automatically animate from the current width to the new width
    if (currentProgress !== previousProgressRef.current) {
      barRef.current.style.width = `${visualProgress}%`;
      previousProgressRef.current = currentProgress;
    }
  }, [progress]);

  return <div ref={barRef} className={css.bar} />;
};
